import React from 'react';

import { Icon } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { ModalHeading as BaseModalHeading } from 'components/modal';

import IconWrap from './icon-wrap';
import { PickUpIcon } from './pickup-icon';
import theme from './theme';
import { IPrompt } from './types';

const TextWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  text-transform: capitalize;
  text-align: left;
`;

const Details = styled.p`
  font-family: ${Styles.fontFamily.body};
  font-size: 0.8125rem;
  letter-spacing: -0.01rem;
  color: ${theme.promptDetailColor};
  text-transform: none;
  margin: 0;
  margin-top: 0.5rem;
`;

export const ModalHeading = () => {
  const { formatMessage } = useIntl();
  return (
    <BaseModalHeading id="modal-heading">
      {formatMessage({ id: 'serviceModePrompt' })}
    </BaseModalHeading>
  );
};

export const DeliveryPrompt: React.FC<IPrompt> = ({ enabled, offerUnavailableForDelivery }) => {
  const { formatMessage } = useIntl();
  return (
    <>
      <IconWrap aria-hidden>
        <Icon icon="delivery" color="icon-active" height="40px" aria-hidden />
      </IconWrap>
      <TextWrapper>
        {enabled ? formatMessage({ id: 'delivery' }) : formatMessage({ id: 'deliveryUnavailable' })}
        {offerUnavailableForDelivery && (
          <Details data-testid="offer-unavailble-for-delivery-text" aria-hidden>
            {formatMessage({ id: 'offerUnavailableForDelivery' })}
          </Details>
        )}
      </TextWrapper>
    </>
  );
};

export const PickUpPrompt: React.FC<IPrompt> = ({ enabled, offerUnavailableForPickup }) => {
  const { formatMessage } = useIntl();
  return (
    <>
      <PickUpIcon />
      <TextWrapper>
        {enabled ? formatMessage({ id: 'pickUp' }) : formatMessage({ id: 'pickupUnavailable' })}
        {offerUnavailableForPickup && (
          <Details data-testid="offer-unavailable-for-pickup-text" aria-hidden>
            {formatMessage({ id: 'offerUnavailableForPickup' })}
          </Details>
        )}
      </TextWrapper>
    </>
  );
};

export const CateringPickUpPrompt: React.FC<IPrompt> = () => {
  const { formatMessage } = useIntl();
  return (
    <>
      <IconWrap aria-hidden>
        <Icon icon="catering" color="icon-active" height="40px" aria-hidden />
      </IconWrap>
      <TextWrapper>{formatMessage({ id: 'cateringPickUp' })}</TextWrapper>
    </>
  );
};

export const CateringDeliveryPrompt: React.FC<IPrompt> = ({ enabled }) => {
  const { formatMessage } = useIntl();
  return (
    <>
      <IconWrap aria-hidden>
        <Icon icon="delivery" color="icon-active" height="40px" aria-hidden />
      </IconWrap>
      <TextWrapper>
        {enabled
          ? formatMessage({ id: 'cateringDelivery' })
          : formatMessage({ id: 'cateringDeliveryUnavailable' })}
      </TextWrapper>
    </>
  );
};
